var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowTopIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_268_607)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.293 16.5672C11.4805 16.7547 11.7348 16.86 12 16.86C12.2652 16.86 12.5195 16.7547 12.707 16.5672L18.364 10.9102C18.4595 10.818 18.5357 10.7076 18.5881 10.5856C18.6405 10.4636 18.6681 10.3324 18.6692 10.1996C18.6704 10.0668 18.6451 9.93515 18.5948 9.81225C18.5445 9.68936 18.4703 9.5777 18.3764 9.48381C18.2825 9.38992 18.1708 9.31567 18.0479 9.26538C17.9251 9.2151 17.7934 9.1898 17.6606 9.19096C17.5278 9.19211 17.3966 9.2197 17.2746 9.2721C17.1526 9.32451 17.0422 9.4007 16.95 9.49621L12 14.4462L7.04999 9.49621C6.86139 9.31405 6.60879 9.21325 6.34659 9.21553C6.0844 9.21781 5.83358 9.32298 5.64817 9.50839C5.46277 9.6938 5.3576 9.94461 5.35532 10.2068C5.35304 10.469 5.45383 10.7216 5.63599 10.9102L11.293 16.5672Z",
    fill: "#E6E6E6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_268_607"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(-1 0 0 1 24 0.860107)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTopIcon);
export default __webpack_public_path__ + "static/media/arrow_top-icon.a2dbb1fed474923fdff6e8ac12bb18d5.svg";
export { ForwardRef as ReactComponent };